(function($){
    $(document).ready(function(){
        $('#mobileMenu a[href^="#"], .top-menu a[href^="#"], a[href^="#contact"]').click(function(event){
            event.preventDefault();
            $('#mobileMenu').hide();
            $('html, body').animate({
                scrollTop: $( $.attr(this, 'href') ).offset().top
            }, 500);
            $('body').removeClass('hiddenBody');
        });
    })
})(jQuery)